import React, {useState, useEffect} from "react"
import { Button } from "react-bootstrap";
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Table from 'react-bootstrap/Table'
import { ToastContainer, toast } from 'react-toastify';
// ****** DataTable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
// Bootstrap
//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';
//import { Input } from "react-select/animated";
DataTable.use(DT);

const DiasAsuetoForm = ({usuario, apiUrl}) => {
    const notify = () => toast.success("Se actualizó el estatus");
    const dateFechaActual = new Date();
    //dateFechaActual.setHours(0, 0, 0, 0);
    //
    const [idDiaAsuetoSelected, setIdDiaAsuetoSelected] = useState(-1);
    const [fechaDiaAsuetoSelected, setFechaDiaAsuetoSelected] = useState(dateFechaActual);
    const [diaAsuetoDesSelected, setDiaAsuetoDesSelected] = useState("");
    const [diaAsuetoEstadoSelected, setDiaAsuetoEstadoSelected] = useState();
    //
    const [showModal, setShowModal] = useState(false);
    // 
    const [diasAsueto, setDiasAsueto] = useState([]);

    useEffect(()=>{
        obtenDiasAsueto();
    }, [])

    const obtenDiasAsueto = ()=>{
        axios.post(`${apiUrl}/diasAsueto/obtenTodosDiasAsueto?token=${sessionStorage.getItem('token')}`, {})
            .then((objResponse) => {
                setDiasAsueto(objResponse.data.result)
            })
            .catch((error) => {
                alert('hubo un error al recuperar las horas de tus colaboradores: ' + error.response.data)
            });
    }

    const guardaDiaAsueto = (paramIdDiaAsueto, paramfechaDiaAsueto, paramDiaAsuetoDes, paramEstado) => {
        axios.post(`${apiUrl}/diasAsueto/guardaDiaAsueto?token=${sessionStorage.getItem('token')}`, 
        {
            idDiaAsueto: paramIdDiaAsueto,
            fechaDiaAsueto: paramfechaDiaAsueto,
            diaAsuetoDes: paramDiaAsuetoDes,
            IDUSUARIOMODIFICACION: usuario.IDUSUARIO,
            Activo: (paramEstado) ? 1 : 0
        })
        .then((objResponse) => {
            obtenDiasAsueto();
            setShowModal(false);
            notify()
        })
        .catch((error) => {
            alert('hubo un error al actualizar el estado del día: ' + error.response.data)
        });
    };

    const columns = [
        { data: 'idDiaAsueto', width: "25%"},
        { data: 'fechaDiaAsueto', width: "25%"},
        { data: 'diaAsuetoDes', width: "25%"},
        { title: 'Activar/Inactivar día', width: "25%"},
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_',
        infoFiltered: '(filtrados de un total de _MAX_ registros encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero registros encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    return (
        <Container>
        <Modal show={showModal}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar día de asueto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped hover responsive>
                    <tbody>
                        <tr>
                            <td>Fecha del día de asueto</td>
                            <td>
                                <Form.Control type="date" value={fechaDiaAsuetoSelected} onChange={(event)=>{setFechaDiaAsuetoSelected(event.target.value)}} />
                            </td>
                        </tr>
                        <tr>
                            <td>Descripción del día de asueto</td>
                            <td>
                                <Form.Control type="text" value={diaAsuetoDesSelected} onChange={(event)=>{setDiaAsuetoDesSelected(event.target.value)}} />
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={()=>{setShowModal(false)}}>Close</Button>
                <Button 
                    variant="primary" 
                    onClick={()=>{
                        guardaDiaAsueto(-1, fechaDiaAsuetoSelected, diaAsuetoDesSelected, true)
                        
                    }}
                >Guardar cambios</Button>
            </Modal.Footer>
        </Modal>
            <Row>
                <Col>
                    <label>Agregar día de asueto</label> 
                    <i className="btn btn-success btn-sm bi bi-calendar-plus-fill" onClick={()=>{setShowModal(true)}}></i>
                    <ToastContainer />
                </Col>
            </Row>
            <Row>
                <Col>
                    <DataTable
                        columns={columns} 
                        data={diasAsueto}  
                        className="display"
                        options={options}
                        responsive={true}
                        slots={{
                            3: (data, row) => (
                                <Form.Check 
                                    type="switch"
                                    id="custom-switch"
                                    defaultChecked={row.activo}
                                    onChange={(event)=>{
                                        guardaDiaAsueto(row.idDiaAsueto, null, null, event.target.checked)
                                        //console.log(`Columna: ${row.activo}`)
                                        console.log(`Estado switch: ${event.target.checked}`)
                                    }}
                                />
                            )
                        }}
                        >
                        <thead>
                            <tr>
                                <th>id día asueto</th>
                                <th>Fecha</th>
                                <th>Descripción</th>
                                <th>Activar/Inactivar día</th>
                            </tr>
                        </thead>
                    </DataTable>
                </Col>
            </Row>
        </Container>
    )
}

export default DiasAsuetoForm;